/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';

import {
  DropdownIndicator,
  formatDataForSelectDropdown,
  formatGroupLabel,
  getTranslatedText,
  IndicatorSeparator
} from '@nile/components';
import { IntlShape, useIntl } from 'react-intl';
import { Dropdown } from '@superops/ui-design-system';
import { AccountClient, GET_ALL_TAX } from '@nile/graphql';

function TaxSelector({
  salesTax,
  onChange,
  isDisabled,
  mode = 'edit',
  defaultMenuIsOpen = false
}: {
  mode?: 'edit' | 'view';
  salesTax?: { taxId: string; name?: string };
  onChange?: (selectedTaxRate: { taxId: string; name?: string }) => void;
  isDisabled?: boolean;
  defaultMenuIsOpen?: boolean;
}) {
  const intl: IntlShape = useIntl();

  const { loading: taxLoading, error: taxError, data: taxData } = useQuery(
    GET_ALL_TAX,
    {
      client: AccountClient
    }
  );

  const taxRateList = taxData?.getAllTax
    ? formatDataForSelectDropdown(taxData?.getAllTax)
    : [];

  const selectedTax = salesTax
    ? taxRateList.find((tax) => {
        return tax?.taxId === salesTax?.taxId;
      })
    : null;

  if (mode === 'view') {
    return <div>{selectedTax?.name || salesTax?.name}</div>;
  }

  return (
    <div className="fg1">
      <Dropdown
        classNamePrefix="value_selector"
        formatGroupLabel={formatGroupLabel}
        components={{ IndicatorSeparator, DropdownIndicator }}
        title={getTranslatedText(intl, 'admin.serviceCatalog.taxRegion')}
        onChange={onChange}
        options={taxRateList}
        placeholder={getTranslatedText(
          intl,
          'admin.serviceCatalog.selectTaxRegion'
        )}
        menuPortalTarget={document.body}
        menuPlacement="auto"
        closeMenuOnScroll={(e) => {
          return (
            e.target &&
            e.target.classList &&
            !(e.target.classList.value.indexOf('menu-list') > -1)
          );
        }}
        defaultMenuIsOpen={!!defaultMenuIsOpen}
        autoFocus={!!defaultMenuIsOpen}
        value={selectedTax}
        name="valueselector"
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({ ...base, zIndex: 9999 })
        }}
        noOptionsMessage={() => {
          return taxLoading ? 'Loading...' : 'No options';
        }}
        isLoading={taxLoading}
        isClearable
        isDisabled={isDisabled}
      />
    </div>
  );
}

export default TaxSelector;
